import * as SeasonPassAPI from "@/API/season-pass.js";

const getDefaultState = () => {
  return {
    activeSeasonPasses: [],
    currentLevelIndexByPassId: {},
    rewardsByPassId: {},
    userByPassId: {},
    tiersByPassId: {},
    isPremiumByPassId: {},
  };
};

const state = getDefaultState();

const mutations = {
  resetState(state) {
    Object.assign(state, getDefaultState());
  },
  setActiveSeasonPasses(state, passes) {
    state.activeSeasonPasses = passes || [];
  },
  setCurrentLevelIndex(state, { passId, index }) {
    state.currentLevelIndexByPassId = {
      ...state.currentLevelIndexByPassId,
      [passId]: index,
    };
  },
  setRewards(state, { passId, rewards }) {
    state.rewardsByPassId = {
      ...state.rewardsByPassId,
      [passId]: rewards,
    };
  },
  setUser(state, { passId, user }) {
    state.userByPassId = {
      ...state.userByPassId,
      [passId]: user,
    };
  },
  advanceUserToLevel(state, { passId, level }) {
    const user = state.userByPassId[passId];
    if (!user || !level) return;

    state.userByPassId = {
      ...state.userByPassId,
      [passId]: {
        ...user,
        progress: 0,
        status: "OPEN",
        level_id: level.id,
        level,
      },
    };
  },
  setTiers(state, { passId, tiers }) {
    state.tiersByPassId = {
      ...state.tiersByPassId,
      [passId]: tiers,
    };
  },
  setIsPremium(state, { passId, isPremium }) {
    state.isPremiumByPassId = {
      ...state.isPremiumByPassId,
      [passId]: !!isPremium,
    };
  },
};

const getters = {
  getCurrentSeasonPass: (state) => state.activeSeasonPasses[0] || null,
  getActiveSeasonPasses: (state) => state.activeSeasonPasses,
  isPremium: (state) => (passId) => !!state.isPremiumByPassId[passId],
  currentLevelIndex: (state) => (passId) =>
    state.currentLevelIndexByPassId[passId] || 0,
  rewards: (state) => (passId) => state.rewardsByPassId[passId] || [],
  user: (state) => (passId) => state.userByPassId[passId] || null,
  tiers: (state) => (passId) => state.tiersByPassId[passId] || [],
};

const actions = {
  fetchActivePasses({ commit }) {
    return SeasonPassAPI.getSeasonPassActive()
      .then((data) => {
        const passes = (data && data.passes) || data || [];
        commit("setActiveSeasonPasses", passes);
        return passes;
      })
      .catch((e) => {
        console.log(e);
        return [];
      });
  },

  loadActivePass({ commit }, { passId }) {
    if (!passId) return Promise.resolve();
    return Promise.all([
      SeasonPassAPI.getSeasonPassUserById(passId),
      SeasonPassAPI.getSeasonPassRewardsById(passId),
      SeasonPassAPI.getSeasonPassUserTiers(passId),
    ])
      .then(([userRes, rewardsRes, tiersRes]) => {
        const user =
          (userRes && userRes.passes && userRes.passes[0]) || userRes || null;
        const rewards = (rewardsRes && rewardsRes.rewards) || rewardsRes || [];
        const tiers = (tiersRes && tiersRes.tiers) || tiersRes || [];

        console.log("[seasonPass] loadActivePass response", {
          passId,
          userRes,
          user,
          rewardsRes,
          tiersRes,
        });

        commit("setUser", { passId, user });
        commit("setRewards", { passId, rewards: Object.values(rewards) });
        commit("setTiers", { passId, tiers });

        const level = (user && user.level && user.level.level) || 0;
        console.log("[seasonPass] set current level index", {
          passId,
          level,
          progress: user && user.progress,
          status: user && user.status,
          levelId: user && user.level_id,
        });
        commit("setCurrentLevelIndex", { passId, index: level });

        const tierPriority = (t) => {
          if (!t) return null;
          if (t.priority != null) return Number(t.priority);
          if (t.tier && t.tier.priority != null) return Number(t.tier.priority);
          return null;
        };
        const isPremium =
          Array.isArray(tiers) && tiers.some((t) => tierPriority(t) === 2);
        commit("setIsPremium", { passId, isPremium });
      })
      .catch((e) => console.log(e));
  },

  purchaseTier({ commit }, { passId, tierId }) {
    return SeasonPassAPI.seasonPassPurchaseTier(passId, tierId).then((res) => {
      commit("setIsPremium", { passId, isPremium: true });
      return res;
    });
  },

  purchaseLevel({ commit }, { passId, level }) {
    return SeasonPassAPI.seasonPassPurchaseLevel(passId, level).then((res) => {
      const user = (res && res.pass) || res;
      if (user) {
        commit("setUser", { passId, user });
        const newLevel = (user.level && user.level.level) || level;
        commit("setCurrentLevelIndex", { passId, index: newLevel });
      }
      return res;
    });
  },

  resetSeasonPassState({ commit }) {
    commit("resetState");
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
